import React from 'react'
import { Link } from 'react-router-dom'
import { Header, Nav, VerticalRule } from '../../styles/navigation.style'
import { TIMELINE_COL_WIDTH_SECOND } from '../../styles/timeline/constants.style'
import { BookLogo } from '../common/BookLogo'
import { useUser } from '../../contextManager/user.context'

export const SimpleHeader: React.FC<{ showAuth?: boolean }> = ({ showAuth }) => {
  const { userDetails } = useUser()
  const logoHref = userDetails ? '/search' : '/'
  return (
    <Header>
      <Nav style={{ justifyContent: showAuth ? 'space-between' : undefined }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <Link to={logoHref} style={{ textDecoration: 'none', display: 'flex', justifyContent: 'center', width: TIMELINE_COL_WIDTH_SECOND }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: 'max-content',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontWeight: 'bold',
                  fontSize: '1.3rem',
                  lineHeight: '1',
                  color: 'var(--colors-slate12, #1e293b)',
                  letterSpacing: '-0.5px',
                }}
              >
                tute
              </span>
              <div style={{ width: '100%', height: '14px', marginTop: '0.1rem'}}>
                <BookLogo />
              </div>
            </div>
          </Link>
          <VerticalRule style={{ marginLeft: 0, marginRight: '0.5rem' }} />
        </div>
        {showAuth && (
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <Link to="/login" style={{
              padding: '0.4rem 1rem', borderRadius: '0.375rem', textDecoration: 'none',
              color: '#1e293b', fontWeight: 500, fontSize: '0.85rem', border: '1px solid #cbd5e1',
              background: 'white',
            }}>Log in</Link>
            <Link to="/register" style={{
              padding: '0.4rem 1rem', borderRadius: '0.375rem', textDecoration: 'none',
              color: 'white', fontWeight: 500, fontSize: '0.85rem', background: '#2563eb',
            }}>Sign up</Link>
          </div>
        )}
      </Nav>
    </Header>
  )
}
